export function formatBrand(brand: string): string {
  return brand + '®';
}

export function formatCommercialOperationSticker(
  sticker: string
): { label: string; background?: string; color?: string } {
  const split = sticker?.split('¤');
  return { label: split[0], background: split[1], color: split[2] };
}

export function formatMainSticker(
  sticker: string
): { label: string; image?: string } {
  const split = sticker?.split('¤');
  return { label: split[0], image: split[1] };
}

export function formatSizesList(sizesList: string): string[] {
  return sizesList.split('¤');
}
